class LinkedProductsPicker extends HTMLElement {
    constructor() {
        super();
        this.productSelect = this.querySelector('select');
        this.productSelect.addEventListener('change', event => this.onProductChange(event));
    }

    onProductChange(event) {
        const selectedProductURL = event.target.value;
        window.location.href = selectedProductURL;
    }
};

customElements.define('linked-products-picker', LinkedProductsPicker);
